/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorSavedArticles as ResolvedLabradorSavedArticles } from 'base/components/labrador/SavedArticles';

export const LabradorSavedArticles: typeof ResolvedLabradorSavedArticles = withLabradorInstanceof((props) => {
    return <ResolvedLabradorSavedArticles {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorSavedArticlesProps = PropsFromComponent<typeof LabradorSavedArticles>;
